import * as React from "react"

import { ReactComponent as ConnectSvg } from 'resources/icons/general/connect_pt1.svg'
import { ReactComponent as WebhookSvg } from 'resources/icons/general/webhook_pt1.svg'

import * as st from './Integrations.styled.js'

const Integrations = () => (
  <st.Wrap>
    <st.Content>
      <st.Title>Integrate your stack</st.Title>
      <st.IntegrationsWrap>
        <st.ProductList>
          <st.ProductItem>
            <st.ProductLogos>
              <st.ProductLogoCircle>
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/hubspot-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/hubspot-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/hubspot-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Hubspot"
                />
              </st.ProductLogoCircle>
              <st.ProductLogoCircle>
                <st.AsteriksIcon />
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/salesforce-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/salesforce-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/salesforce-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Salesforce"
                />
              </st.ProductLogoCircle>
            </st.ProductLogos>
            CRM
          </st.ProductItem>

          <st.ProductItem>
            <st.ProductLogos>
              <st.ProductLogoCircle>
                <st.AsteriksIcon />
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/linear-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/linear-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/linear-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Linear"
                />
              </st.ProductLogoCircle>
              <st.ProductLogoCircle>
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/jira-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/jira-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/jira-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Jira"
                />
              </st.ProductLogoCircle>
            </st.ProductLogos>
            Product
          </st.ProductItem>

          <st.ProductItem>
            <st.ProductLogos>
              <st.ProductLogoCircle>
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/slack.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/slack.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/slack@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Slack"
                />
              </st.ProductLogoCircle>
            </st.ProductLogos>
            Communication
          </st.ProductItem>

          <st.ProductItem>
            <st.ProductLogos>
              <st.ProductLogoCircle>
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/zappier-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/zappier-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/zappier-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Zapier"
                />
              </st.ProductLogoCircle>
              <st.ProductLogoCircle>
                <img
                  src="//cdn-platform.scope-dev.ws/website/images/logos/make-28.png"
                  srcSet="//cdn-platform.scope-dev.ws/website/images/logos/make-28.png 1x, //cdn-platform.scope-dev.ws/website/images/logos/make-28@2x.png 2x"
                  width={28}
                  height={28}
                  alt="Make"
                />
              </st.ProductLogoCircle>
            </st.ProductLogos>
            Other
          </st.ProductItem>
        </st.ProductList>
        <st.Lines>
          <st.LineTopLeftLong />
          <st.LineTopLeftShort />
          <st.LineTopRightLong />
          <st.LineTopRightShort />
        </st.Lines>
        <st.MainArea>
          <st.MessageBlock>
            <st.CaseIcon>
              <ConnectSvg />
            </st.CaseIcon>
            Scope provides native and comprehensive integration with your CRM, Slack, and project management tools.
          </st.MessageBlock>
          <st.ScopeBlock>
            <img
              src="//cdn-platform.scope-dev.ws/website/images/illustrations/scope-integration.png"
              srcSet="//cdn-platform.scope-dev.ws/website/images/illustrations/scope-integration.png 1x, //cdn-platform.scope-dev.ws/website/images/illustrations/scope-integration@2x.png 2x"
              width={194}
              height={222}
              alt="Scope integrations"
            />
          </st.ScopeBlock>
          <st.MessageBlock>
            <st.CaseIcon>
              <WebhookSvg />
            </st.CaseIcon>
            With powerful APIs and webhooks, Scope aligns with your workflow and integrates with any tool you need.
          </st.MessageBlock>
        </st.MainArea>
        <st.Lines>
          <st.LineBottomLeftLong />
          <st.LineBottomLeftShort />
          <st.LineBottomRightLong />
          <st.LineBottomRightShort />
        </st.Lines>
        <st.UseCases>
          <st.Case>
            Send submitted form data into HubSpot deal
          </st.Case>
          <st.Case>
            Sync tasks with Jira assigned to specific role
          </st.Case>
          <st.Case>
            Create project when HubSpot deal change stage
          </st.Case>
          <st.Case>
            Reply on messages in Slack channels and threads
          </st.Case>
        </st.UseCases>
      </st.IntegrationsWrap>
      <st.Disclaimer>* Integration is coming in Q1 25</st.Disclaimer>
    </st.Content>
  </st.Wrap>
)

export default Integrations
